<ng-content select=".input-group-prepend"></ng-content>
<div class="form-select rounded position-relative"
     [ngClass]="{'border-invalid': required && selectedValues.length === 0, 'custom-select-sm': small}"
     [class.disabled]="disabled" [id]="id ? id + '-select' : ''" (click)="toggleDropdown()" tabindex="0"
     style="height: 1.5rem; padding: 0 0.25rem; line-height: 1; display: flex; align-items: center;">
    <div class="px-1 d-flex align-items-center" style="padding-top: 0; padding-bottom: 0;">
        <span class="text-truncate w-100">
            <ng-container *ngIf="selectedValues.length > 0">
                <i class="bi bi-filter me-1 align-middle"></i> Filter
            </ng-container>
        </span>
    </div>
    <div *ngIf="dropdownOpen" (click)="$event.stopPropagation()"
         class="dropdown-menu show w-100 shadow-sm p-2" style="z-index: 1050; min-width: max-content; top: 100%; left: 0;">
        <ng-container *ngFor="let option of _options; let i = index">
            <label class="dropdown-item d-flex align-items-center gap-2 py-2 px-3" [class.text-muted]="isDisabled(option)"
                   [class.disabled]="isDisabled(option)" *ngIf="!optionVisible || optionVisible(option)" [for]="'option-' + i">
                <input [id]="'option-' + i" type="checkbox" class="form-check-input m-0" [checked]="isSelected(option)"
                        (change)="toggleSelection(option)" [disabled]="isDisabled(option)" style="margin-top: 0.1rem;">
                <span class="flex-grow-1">
                    {{ isSelected(option) ? selectedFormatter(option) : formatter(option) }}
                </span>
            </label>
        </ng-container>
    </div>
</div>
<ng-content select=".invalid-feedback"></ng-content>
<ng-content select=".valid-feedback"></ng-content>
